"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = exports.PeopleToggle = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var tree_close_png_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/assets/images/tree-close.png"));
var tree_open_png_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/assets/images/tree-open.png"));
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var react_contextmenu_1 = require("react-contextmenu");
var styled_components_1 = __importStar(require("styled-components"));
var Constants_1 = require("../../Constants");
var HierarchyTypeUtil_1 = require("../../HierarchyTypeUtil");
var HierarchyUtil_1 = require("../../util/HierarchyUtil");
var HtmlUtil_1 = require("../../util/HtmlUtil");
var types_1 = require("../../types");
var PreviewMove_1 = require("./PreviewMove");
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.hierarchy-node-element {\n\t\tfont-size: ", ";\n\t\tpadding: ", " ", ";\n\t\tmargin: 2px;\n\t}\n\t.node-selected {\n\t\tcolor: ", ";\n\t\tbackground-color: #5f6263;\n\t}\n\t.leaf-node{\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tbackground-color: black;\n\t\tborder-radius: 50%;\n\t\tdisplay: inline-block;\n\t\tmargin-left: 6px;\n\t}\n\t.people-toggle {\n\n\t}\n\t.people-toggle.selected {\n\n\t}\n"], ["\n\t.hierarchy-node-element {\n\t\tfont-size: ", ";\n\t\tpadding: ", " ", ";\n\t\tmargin: 2px;\n\t}\n\t.node-selected {\n\t\tcolor: ", ";\n\t\tbackground-color: #5f6263;\n\t}\n\t.leaf-node{\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tbackground-color: black;\n\t\tborder-radius: 50%;\n\t\tdisplay: inline-block;\n\t\tmargin-left: 6px;\n\t}\n\t.people-toggle {\n\n\t}\n\t.people-toggle.selected {\n\n\t}\n"])), globalVars_module_scss_1.default.fontSizeBase, globalVars_module_scss_1.default.spacing5, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.white);
var NodeContainer = styled_components_1.default.li.attrs(function (props) { return (__assign(__assign({}, props), { key: props.node.nodeId, className: 'hierarchy-node' })); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: ", "%;\n"], ["\n\tmargin-left: ", "%;\n"])), function (props) {
    var doIndent = props.doIndent, level = props.level;
    if (!doIndent) {
        return 0;
    }
    if (level === 0) {
        return 50 / Constants_1.Constants.LEVEL;
    }
    return 100 / (Constants_1.Constants.LEVEL - level + 0.5);
});
NodeContainer.displayName = 'NodeContainer';
exports.PeopleToggle = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: 5px;\n\tborder-radius: 50%;\n\tpadding: 4px;\n\tborder: 1px solid #999999;\n\tbackground-color: ", ";\n\tcolor: ", " !important;\n\tpointer-events: ", ";\n\tfont-size: 0.75em;\n\tdisplay: inline-block;\n\theight: 22px;\n\twidth: 22px;\n\ttext-align: center;\n\tvertical-align: middle;\n"], ["\n\tmargin-left: 5px;\n\tborder-radius: 50%;\n\tpadding: 4px;\n\tborder: 1px solid #999999;\n\tbackground-color: ", ";\n\tcolor: ", " !important;\n\tpointer-events: ", ";\n\tfont-size: 0.75em;\n\tdisplay: inline-block;\n\theight: 22px;\n\twidth: 22px;\n\ttext-align: center;\n\tvertical-align: middle;\n"])), function (_a) {
    var selected = _a.selected;
    return (selected ? '#28ABC9' : 'white');
}, function (_a) {
    var selected = _a.selected;
    return (selected ? 'white' : 'black');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
});
var LocationLeafNode = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\theight: 12px;\n\twidth: 12px;\n\tbackground-color: white;\n\tborder: 1px solid #999999;\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tmargin-left: 6px;\n"], ["\n\theight: 12px;\n\twidth: 12px;\n\tbackground-color: white;\n\tborder: 1px solid #999999;\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tmargin-left: 6px;\n"])));
var Node = /** @class */ (function (_super) {
    __extends(Node, _super);
    function Node(props) {
        var _this = _super.call(this, props) || this;
        _this.nodeRef = React.createRef();
        return _this;
    }
    Object.defineProperty(Node.prototype, "Hierarchy", {
        get: function () {
            var hierarchy = this.props.hierarchyHeader;
            return lodash_1.default.merge({}, hierarchy, HierarchyTypeUtil_1.HierarchyTypeUtilFactory.getHierarchyTypeUtil(hierarchy.hierarchyType));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "LevelOf", {
        get: function () {
            var level = this.props.level;
            return {
                children: level + 1,
                related: level,
            };
        },
        enumerable: false,
        configurable: true
    });
    Node.prototype.render = function () {
        var _a = this.props, level = _a.level, nodes = _a.nodes, nodeId = _a.nodeId;
        var node = nodes[nodeId];
        if (!node || (0, HierarchyUtil_1.shouldHideNode)(node)) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            React.createElement(NodeContainer, { node: node, level: level, doIndent: this.Hierarchy.indentNodeAtLevel(node) },
                React.createElement("span", { style: { display: 'inline-block' } }, this.displayNode(node)),
                node.nodeType === types_1.NodeType.Location && node.showBelongsToNodes && (React.createElement("ul", { style: { paddingBottom: '10px' } },
                    " ",
                    this.displayRelatedNodes(node),
                    " ")),
                this.displayChildNodes(node))));
    };
    Node.prototype.componentDidMount = function () {
        var nodeElementRef = this.nodeRef.current;
        if (nodeElementRef && this.props.isMovePreviewNode) {
            var offsetLeft = nodeElementRef.offsetLeft, offsetTop = nodeElementRef.offsetTop, offsetWidth = nodeElementRef.offsetWidth;
            var x = offsetLeft + offsetWidth;
            var y = offsetTop + (this.props.isOrphanBranch ? this.props.topNodesContainer.current.clientHeight : 0);
            this.props.setMoveConfirmationDialogPosition(x, y);
        }
        this.scrollSelectedNodeIntoView();
    };
    Node.prototype.componentDidUpdate = function () {
        var _a = this.props, nodes = _a.nodes, nodeId = _a.nodeId;
        var node = nodes[nodeId];
        this.scrollSelectedNodeIntoView();
        // If the node is selected to be moved and is currently displaying its related nodes
        if (node.editState && node.showBelongsToNodes) {
            // Hide them
            this.toggleShow('related', node);
        }
        // == If the node is selected as a target for a move, expand/toggle to ensure that the preview is visible == //
        if (this.shouldDisplayMovePreview(node, 'related', this.props.hierarchyEditState) && !node.showBelongsToNodes) {
            this.toggleShow('related', node);
        }
        if (this.shouldDisplayMovePreview(node, 'children', this.props.hierarchyEditState) && !node.isExpanded) {
            this.toggleShow('children', node);
        }
    };
    Node.prototype.shouldComponentUpdate = function (nextProps) {
        var nodeId = this.props.nodeId;
        var curNodeVm = this.props.nodes[nodeId];
        var nextNodeVm = nextProps.nodes[nodeId];
        // Without the condition below, all nodes will be re-rendered whenever there is a change in
        // nodes collection even though the current node is not modified
        var shouldUpdate = curNodeVm !== nextNodeVm ||
            this.props.selectedNodeId !== nextProps.selectedNodeId ||
            this.props.hierarchyEditState !== nextProps.hierarchyEditState;
        return shouldUpdate;
    };
    Node.prototype.scrollSelectedNodeIntoView = function () {
        var _a = this.props, pendingSelectedNodeScroll = _a.pendingSelectedNodeScroll, selectedNodeId = _a.selectedNodeId;
        var nodeElementRef = this.nodeRef.current;
        if (pendingSelectedNodeScroll && selectedNodeId && nodeElementRef && selectedNodeId === nodeElementRef.id) {
            var bounding = nodeElementRef.getBoundingClientRect();
            var halfScreenHeight = window.innerHeight / 2;
            if (!this.isInViewPort(bounding)) {
                var options = {
                    behavior: 'smooth',
                    top: bounding.top + window.scrollY - halfScreenHeight,
                    left: bounding.left + window.scrollX,
                };
                if ((0, HtmlUtil_1.IsIE)()) {
                    // For lower version of IE
                    window.scrollTo(bounding.left + window.scrollX, bounding.top + window.scrollY - halfScreenHeight);
                }
                else {
                    window.scrollTo(options);
                }
                this.props.resetPendingScroll();
            }
        }
    };
    // Taken from https://gomakethings.com/how-to-test-if-an-element-is-in-the-viewport-with-vanilla-javascript/
    Node.prototype.isInViewPort = function (bounding) {
        var _a, _b;
        return (
        // we are using 100 here to offset search bar in move mode
        bounding.top >= 100 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || ((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0) &&
            bounding.right <= (window.innerWidth || ((_b = document.documentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0));
    };
    Node.prototype.displayNode = function (node) {
        var _this = this;
        var nodeId = node.nodeId;
        var _a = this.props, hierarchyEditState = _a.hierarchyEditState, selectNode = _a.selectNode;
        var contextMenuConfig = {
            id: Constants_1.Constants.HIERARCHY_MENU_ID,
            holdToDisplay: -1,
            // Trigger action
            collect: function () {
                var _a, _b;
                selectNode(nodeId);
                // Data to propogate to context menu
                return {
                    nodeId: node.nodeId,
                    nodeType: node.nodeType,
                    nodeDisplayName: _this.Hierarchy.getNodeDisplayName({ nodeVm: node, hierarchyEditState: hierarchyEditState }),
                    isLeafNode: _this.Hierarchy.isLeafNode(node),
                    isOpenNode: _this.Hierarchy.isOpenNode(node),
                    isTopNode: _this.props.level === 0,
                    isRootNode: _this.props.isRootNode,
                    peopleDirectlyUnder: ((_a = node.directEmployeeCount) !== null && _a !== void 0 ? _a : 0) + ((_b = node.directOpenPositions) !== null && _b !== void 0 ? _b : 0),
                };
            },
        };
        return (React.createElement(react_contextmenu_1.ContextMenuTrigger, __assign({}, contextMenuConfig),
            this.ViewChildrenToggle(node),
            this.BelongsToToggle(node),
            this.NodeElement(node)));
    };
    Node.prototype.ViewChildrenToggle = function (node) {
        if (this.Hierarchy.isLeafNode(node)) {
            return node.nodeType === types_1.NodeType.Location ? React.createElement(LocationLeafNode, null) : React.createElement("span", { className: 'leaf-node' });
        }
        return (React.createElement("a", { className: 'toggle-node', onClick: this.onExpand(node, 'children') },
            React.createElement("img", { src: node.isExpanded ? tree_open_png_1.default : tree_close_png_1.default })));
    };
    Node.prototype.BelongsToToggle = function (node) {
        if (!this.Hierarchy.showPeopleToggle(node)) {
            return null;
        }
        var disabled = this.Hierarchy.disablePeopleToggle(node);
        return (React.createElement(exports.PeopleToggle, { selected: !!node.showBelongsToNodes, disabled: disabled, onClick: this.onExpand(node, 'related') },
            React.createElement(aon_tws_common_ui_1.Icon, { name: 'person' })));
    };
    Node.prototype.NodeElement = function (node) {
        var nodeId = node.nodeId;
        var selectedNodeId = this.props.selectedNodeId;
        var elementProps = {
            id: nodeId,
            ref: this.nodeRef,
            style: { display: 'inline-block' },
            className: "hierarchy-node-element ".concat(selectedNodeId === nodeId ? 'node-selected' : ''),
            onClick: this.onSelect(node),
        };
        return React.createElement("span", __assign({}, elementProps), this.NodeText(node));
    };
    Node.prototype.NodeText = function (node) {
        var hierarchyEditState = this.props.hierarchyEditState;
        var displayText = this.Hierarchy.getNodeDisplayName({
            fullName: true,
            nodeVm: node,
            hierarchyEditState: hierarchyEditState,
        });
        if (node.nodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID) {
            return React.createElement("i", null, displayText);
        }
        if (this.props.isMovePreviewNode) {
            return React.createElement("b", null, displayText);
        }
        return displayText;
    };
    Node.prototype.onExpand = function (node, view) {
        var _this = this;
        return function (e) {
            e.preventDefault();
            _this.toggleShow(view, node);
        };
    };
    Node.prototype.onSelect = function (node) {
        var _this = this;
        return function (e) {
            var _a = _this.props, hierarchyEditState = _a.hierarchyEditState, nodes = _a.nodes, parentIds = _a.parentIds;
            var nodeId = node.nodeId;
            e.preventDefault();
            // If the node is selected as the target for a move operation
            if ((0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState)) {
                var moving = nodes[hierarchyEditState.selectedNodeId];
                if (!_this.Hierarchy.isValidMoveDestination(node, moving, parentIds)) {
                    return;
                }
                var moveIntoNodeElem = _this.nodeRef.current;
                if (moveIntoNodeElem) {
                    var offsetLeft = moveIntoNodeElem.offsetLeft, offsetTop = moveIntoNodeElem.offsetTop, offsetWidth = moveIntoNodeElem.offsetWidth;
                    var x = offsetLeft + offsetWidth;
                    var y = offsetTop + (_this.props.isOrphanBranch ? _this.props.topNodesContainer.current.clientHeight : 0);
                    _this.props.selectMoveDestinationNode(nodeId, _this.Hierarchy.getNodeDisplayName({ nodeVm: node, hierarchyEditState: hierarchyEditState }), x, y);
                }
                return;
            }
            _this.props.selectNode(nodeId);
        };
    };
    Node.prototype.toggleShow = function (type, forNode) {
        var nodeId = forNode.nodeId;
        if (type === 'children') {
            this.props.toggleNode(nodeId, forNode.isExpanded);
        }
        if (type === 'related') {
            this.props.toggleShowBelongsToNodes(nodeId);
        }
    };
    Node.prototype.displayChildNodes = function (node) {
        var _this = this;
        var _a = this.props, hierarchyEditState = _a.hierarchyEditState, nodes = _a.nodes;
        var children = node.childrenIds;
        // If another node is being moved underneath this node
        if (this.shouldDisplayMovePreview(node, 'children', hierarchyEditState)) {
            return (React.createElement(PreviewMove_1.PreviewMove, { hierarchy: this.props, moveInto: children, renderNode: function (n, asPreview) { return _this.renderDescendant(n, _this.LevelOf['children'], asPreview); } }));
        }
        if (this.Hierarchy.isLeafNode(node) || !node.isExpanded) {
            return null;
        }
        return React.createElement("ul", null, children.map(function (id) { return _this.renderDescendant(nodes[id], _this.LevelOf['children']); }));
    };
    Node.prototype.displayRelatedNodes = function (node) {
        var _this = this;
        var _a, _b;
        var _c = this.props, nodes = _c.nodes, hierarchyEditState = _c.hierarchyEditState;
        var _d = node.belongsToNodeIds, relatedNodes = _d === void 0 ? [] : _d;
        if (this.shouldDisplayMovePreview(node, 'related', hierarchyEditState)) {
            return (React.createElement(PreviewMove_1.PreviewMove, { hierarchy: this.props, moveInto: relatedNodes, renderNode: function (n, asPreview) { return _this.renderDescendant(n, _this.LevelOf['related'], asPreview); } }));
        }
        if (!relatedNodes.length) {
            return React.createElement("li", null, "No employees exist at this level");
        }
        return (React.createElement(React.Fragment, null,
            relatedNodes.map(function (id) { return _this.renderDescendant(nodes[id], _this.LevelOf['related']); }),
            ((_b = (_a = node.belongsToPageRange) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : 0) > relatedNodes.length && (React.createElement(aon_tws_common_ui_1.Button, { size: 'xs', onClick: function () { return _this.props.loadMoreBelongsToNodes(node.nodeId); }, className: 'tws-button-load-more-belongs-to-nodes' }, "Load More"))));
    };
    Node.prototype.renderDescendant = function (node, level, asMovePreview) {
        var _a;
        var nodeId = node.nodeId;
        return (React.createElement(Node, __assign({}, this.props, { key: nodeId, nodeId: nodeId, nodes: __assign(__assign({}, this.props.nodes), (_a = {}, _a[nodeId] = __assign(__assign({}, node), { isOrphan: false }), _a)), isRootNode: false, level: level, isMovePreviewNode: !!asMovePreview })));
    };
    Node.prototype.shouldDisplayMovePreview = function (node, under, hierarchyEditState) {
        var nodeId = node.nodeId, nodeType = node.nodeType;
        if (!(0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState)) {
            return false;
        }
        var selectedDestinationNodeId = hierarchyEditState.selectedDestinationNodeId, replaceDestination = hierarchyEditState.replaceDestination;
        var isMovingUnder = selectedDestinationNodeId === nodeId && replaceDestination === false;
        if (!isMovingUnder) {
            return false;
        }
        if (nodeType === types_1.NodeType.Location) {
            return under === 'related';
        }
        else {
            return under === 'children';
        }
    };
    return Node;
}(React.Component));
exports.Node = Node;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
